import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useParams } from "react-router-dom";
import PropTypes from "prop-types";

// Material
import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";

// Config
import colors from "src/config/colors";
import { getRoute, urls } from "src/config/routes";
import useTranslate from "src/hooks/useTranslate";
import useQuery from "src/hooks/useQuery";

// Component
import Button from "src/components/Button";
import Link from "src/components/Link";
import Text from "src/components/Text";

// Icon
import lightBulbIcon from "src/assets/icons/light_bulb.svg";
import sentOkIcon from "src/assets/icons/sentOkIcon.svg";

const useStyles = makeStyles(theme => ({
  boxContainer: {
    padding: theme.spacing(5),
    border: "1px solid #3AE161",
    backgroundColor: "#E6F7EC",
    borderRadius: theme.shape.borderRadius,
    gap: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    width: "100%"
  },
  boxTitle: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  },
  title: {
    padding: theme.spacing(2),
    color: "#3AE161"
  },
  evidenceBox: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    padding: theme.spacing(3),
    borderRadius: 10,
    backgroundColor: colors.white,
    gap: theme.spacing(2),
    width: "100%"
  },
  evidenceContent: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1)
  },
  adviceDescription: {
    whiteSpace: "pre-line"
  }
}));

const ConfirmationCard = ({ isSai }) => {
  const { caseId } = useParams();
  const classes = useStyles();
  const getText = useTranslate();
  const query = useQuery();

  const source = query.get("source");

  const to = getRoute(isSai ? urls.sai : urls.statements, { caseId });

  const buttonProps =
    source === "android"
      ? {
          component: "a",
          href: to
        }
      : {
          component: Link,
          to
        };

  return (
    <Paper className={classes.boxContainer} elevation={0}>
      <Box className={classes.boxTitle}>
        <img className={classes.icon} src={sentOkIcon} alt="" />
        <Text
          type="heading3"
          className={classes.title}
          text="statementPage.completedTitle"
        />
      </Box>
      <Text
        type="body1"
        text={
          isSai
            ? "selfAdministeredInterviewsPage.successDescription"
            : "statementPage.successDescription"
        }
      />
      {isSai && (
        <Box className={classes.evidenceBox}>
          <img src={lightBulbIcon} alt="" height={16} />
          <Box className={classes.evidenceContent}>
            <Text
              type="contentBold"
              text="selfAdministeredInterviewsPage.adviceTitle"
            />
            <Text
              type="body1"
              className={classes.adviceDescription}
              text="selfAdministeredInterviewsPage.adviceDescription"
            />
          </Box>
        </Box>
      )}
      <Button variant="outlined" {...buttonProps}>
        {getText("statementPage.backButton").toUpperCase()}
      </Button>
    </Paper>
  );
};

ConfirmationCard.propTypes = {
  isSai: PropTypes.bool.isRequired
};

export default ConfirmationCard;
